let state = {};

export default {
  setItem(key, value) {
    state = { ...state, [key]: value };
  },
  getItem(key) {
    return state[key];
  },
};
